import { useState } from "react";
import { client } from "../../services/networking.service";

interface CollectionCode {
  _id: string;
  code: string;
  key_id: string;
  owner_id: string;
  label: string;
  is_reusable: boolean;
  max_uses: number | null;
  times_used: number;
  expires_at: number | null;
  is_permanent: boolean;
  status: 'active' | 'expired' | 'revoked' | 'depleted';
  is_active: boolean;
  created_by: string;
  revoked_at: number | null;
  revoked_by: string | null;
  revoked_reason: string;
  last_used_at: number | null;
  notes: string;
  createdAt: string;
  updatedAt: string;
}

interface CollectionCodesResponse {
  success: boolean;
  data: {
    codes: CollectionCode[];
    pagination: {
      page: number;
      limit: number;
      total: number;
      pages: number;
    };
    summary: {
      total: number;
      active: number;
      expired: number;
      revoked: number;
      depleted: number;
    };
  };
}

interface GetCollectionCodesParams {
  keyId: string;
  status?: 'active' | 'expired' | 'revoked' | 'depleted';
  page?: number;
  limit?: number;
}

export const useGetCollectionCodes = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getCollectionCodes = async (params: GetCollectionCodesParams): Promise<CollectionCodesResponse | null> => {
    setLoading(true);
    setError(null);

    try {
      const queryParams = new URLSearchParams();
      if (params.status) queryParams.append('status', params.status);
      if (params.page) queryParams.append('page', params.page.toString());
      if (params.limit) queryParams.append('limit', params.limit.toString());

      const queryString = queryParams.toString();
      const url = `admin/keys/${params.keyId}/collection-codes${queryString ? `?${queryString}` : ''}`;

      const response = await client.get<CollectionCodesResponse>(url);

      setLoading(false);
      return response.data;
    } catch (err: any) {
      setLoading(false);
      setError(err.message || 'Failed to fetch collection codes');
      return null;
    }
  };

  return {
    getCollectionCodes,
    loading,
    error,
  };
};

export type { CollectionCode, CollectionCodesResponse, GetCollectionCodesParams };